export class Responses {

    static VerifyOtpResError = class {

        public static CODE_EXPIRED = 403;

    }
    
}